module.exports = __webpack_public_path__ + "img/exp_icon.828ec133.png";